module.exports = __webpack_public_path__ + "img/logo-istry-login.ea95fa90.png";